import { useCallback } from 'react';

const useFilterFacetValues = (
  attribute: string,
  facetFilters: Array<string|Array<string>>,
): Function => {
  return useCallback((): Array<string|Array<string>> => {
    return [...facetFilters.filter((item: string | Array<string>) => {
      if (Array.isArray(item)) {
        return !item.some((facet: string) => facet.indexOf(attribute) !== -1);
      }
      return item.indexOf(attribute) === -1;
    })];
  }, [attribute, facetFilters]);
};

export default useFilterFacetValues;
